import React from "react";
import styled from "styled-components";
import mobile from "../../assets/img/mobile.png";
import AnimatedShapes from "../AnimatedShapes";

const Container = styled.div`
  display: flex;
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
  }
`;

const Left = styled.div`
  width: 50%;
`;

const Image = styled.img`
  width: 86%;
`;
const Right = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 480px) {
    width: 70%;
  }
`;

const Title = styled.div`
  font-size: 70px;

  @media only screen and (max-width: 480px) {
    font-size: 25px;
  }
`;
const FirstDescription = styled.div`
  margin-top: 20px;
  font-size: 30px;
  color: #000;
  @media only screen and (max-width: 480px) {
    font-size: 20px;
  }
`;
const Description = styled.div`
  margin-top: 20px;
  font-size: 20px;
  color: #777;
  @media only screen and (max-width: 480px) {
    font-size: 15px;
  }
`;

const Button = styled.div`
  padding: 15px 20px;
  background-color: darkblue;
  border-radius: 10px;
  margin-top: 20px;
  color: white;
  cursor: pointer;
  width: 200px;
  text-align: center;
  border: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: bold;

  &:hover {
    background-color: blue;
  }
  @media only screen and (max-width: 480px) {
    width: 130px;
    padding: 10px 15px;
    letter-spacing: 1px;
  }
`;

const LinkRel = styled.a`
  text-decoration: none;
  color: white;
`;

const Feature = () => {
  return (
    <Container id="Features">
      <Left>
        <Image src={mobile} />
      </Left>
      <Right>
        <Title>
          <strong>good</strong> design <br /> <strong>good</strong> business
        </Title>
        <FirstDescription>
          <i>We know that good design means good business.</i>
        </FirstDescription>
        <Description>
          We help our clients succeed by creating brand identities, digital
          experiences, and print materials that communicate clearly, achieve
          marketing goals, and look fantastic.
        </Description>
        <Description>
          We care your business and guarantee you to achieve marketing goals.
        </Description>
        <Button>
          <LinkRel href="https://tn.linkedin.com/in/mahmoud-ayed-111329207">
            Learn More
          </LinkRel>
        </Button>
      </Right>
      <AnimatedShapes />
    </Container>
  );
};

export default Feature;
